export default __webpack_public_path__ + "c548d252a08702ca3453b0b63e1288db.svg";